import type {
  CostreportV1beta1GetClusterScoreHistoryV2ResponseScoreItem,
  CostreportV1beta1GetClusterScoreHistoryV2Response,
} from '@cast/openapi';

export type {
  ClusterReportAPIApiClusterReportAPIRecalculateClusterScoreRequest as ClusterScoreRegenerateRequestParams,
  CostreportV1beta1GetClusterScoreHistoryV2Response,
  CostreportV1beta1GetClusterScoreV2ResponseCategory as ClusterScoreV2Category,
  CostreportV1beta1GetClusterScoreV2ResponseCategorySubcategory as ClusterScoreV2Subcategory,
  CostreportV1beta1GetClusterScoreV2ResponseCategorySubcategoryCheck as ClusterScoreV2Check,
} from '@cast/openapi';

export type {
  ListClusterRestrictionsResponse,
  ListClusterRestrictionsResponseResourceRestrictions,
  ClusterRestrictionDetails,
  ClusterRestrictionDetailsManifest,
  ClusterRestrictionDetailsRestriction,
  RestrictionIssue,
  RestrictionSilence,
  ListRestrictionSilencesResponse,
  PreviewRestrictionSilenceResponse,
} from '@cast/openapi-reporting';

export const ClusterScoreState = {
  Unknown: 'Unknown',
  Poor: 'Poor',
  Concerning: 'Concerning',
  Healthy: 'Healthy',
} as const;

export type ClusterScoreState =
  (typeof ClusterScoreState)[keyof typeof ClusterScoreState];

export type ClusterScoreHistoryItem =
  CostreportV1beta1GetClusterScoreHistoryV2ResponseScoreItem & {
    timestamp: string;
  };

export type ClusterScoreHistoryResponse =
  CostreportV1beta1GetClusterScoreHistoryV2Response & {
    items: ClusterScoreHistoryItem[];
  };
